<script>
    import {createEventDispatcher} from "svelte";
    import { t } from '../core/i18n/language-store';
    const dispatch = createEventDispatcher();

    export let publishConfig;
    export let price;

    function addToCartHandler () {
        if (!publishConfig?.disableCart) {
            dispatch('clicked', {});
        }
    }

</script>

<style>
    .price-button {
        border: none;
        border-radius: .25rem;

        padding: .9rem 1.25rem;
        width: 100%;
        font-size: var(--fs-100);
        font-family: inherit;

        color: var(--bg-color);
        background-color: var(--accent-color);
        box-shadow: 0 6px 4px 0 rgb(0 0 0 / 10%); /**0 6px 9px 4px rgb(0 0 0 / 8%);**/

        transition: background-color .2s ease, transform .1s ease-in;
    }
    .price-button:active {
        background-color: var(--accent-color-semi);
        transform: scale(.97);
    }
    .price-button div:last-child {
        text-transform: uppercase;
    }
    .price-button small {
        font-weight: 200;
        opacity: .7;
    }
    .price {
        font-family: PT Mono, sans-serif;
    }
</style>

<button class="price-button pointer flex-between ai-center lh-1 user-select-none"
        disabled:={publishConfig.disableCart}
        on:click={addToCartHandler} >
    <div>
        <span class="price price-pair" class:price-pair--rev={publishConfig?.currency === '$'}>
            <span>{ price.totalPrice }</span>
            <span>{ publishConfig?.currency || '' }</span>
        </span>

        {#if (price?.selectedVariant?.weight !== undefined)}
            <small>/ { price.selectedVariant.weight }</small>
        {/if}
    </div>

    {#if (publishConfig.disableCart !== true)}
        <div>{$t('buttons.addToCart')}</div>
    {/if}
</button>
